<template>
	<div class="layout-topbar">
		<router-link to="/" class="layout-topbar-logo">
			<img alt="Logo" src="images/kronopsy.png" />
		</router-link>
	</div>
</template>
